// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-circle {
  width: 40px;
  height: 40px;
  border-radius: 21px;
  background: #79B8E6;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(9, 132, 227, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.profile-circle:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(9, 132, 227, 0.3);
}

.profile-circle:active {
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/shared/profile-icon/profile-icon.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4CAA4C;EAC5C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".profile-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 21px;\n  background: #79B8E6;\n  color: white;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(9, 132, 227, 0.2);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.profile-circle:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(9, 132, 227, 0.3);\n}\n\n.profile-circle:active {\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
